import Vue from 'vue';
import VueRouter from 'vue-router';
import Home from '../views/Home.vue';
import Login from '../views/Login.vue';
import People from '../views/People.vue';
import Calendar from '../views/Calendar.vue';
import Files from '../views/Files.vue';
import Reports from '../views/Reports.vue';
import Checkins from '../views/Checkins.vue';
import SubmitCheckin from '../views/SubmitCheckin.vue';
import Assignments from '../views/Assignments.vue';
import SubmitReport from '../views/SubmitReport.vue';
import Queue from '../views/Queue.vue';
import Rooms from '../views/Rooms.vue';
import Videos from '../views/Videos.vue';
import PlayVideo from '../views/PlayVideo.vue';
import WatchParty from '../views/WatchParty.vue';
import WatchPartyConvener from '../views/WatchPartyConvener.vue';
import RecentEvents from '../views/RecentEvents.vue';
import PathNotFound from '../views/PathNotFound.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/watch-party/',
    name: 'watch-party',
    component: WatchParty,
  },
  {
    path: '/convene/:id',
    name: 'watch-party-convener',
    component: WatchPartyConvener,
  },
  {
    path: '/activity',
    name: 'activity',
    component: RecentEvents,
  },
  {
    path: '/videos/',
    name: 'videos',
    component: Videos,
  },
  {
    path: '/videos/:id',
    name: 'play-video',
    component: PlayVideo,
  },
  {
    path: '/users/:id',
    name: 'people-id',
    component: People,
  },
  {
    path: '/users/',
    name: 'people',
    component: People,
  },
  {
    path: '/rooms/',
    name: 'rooms',
    component: Rooms,
  },
  {
    path: '/reports/',
    name: 'reports',
    component: Reports,
  },
  {
    path: '/reports/:user',
    name: 'submit-report',
    component: SubmitReport,
  },
  {
    path: '/checkins/',
    name: 'checkins',
    component: Checkins,
  },
  {
    path: '/checkins/:user',
    name: 'submit-checkin',
    component: SubmitCheckin,
  },
  {
    path: '/calendar/:event',
    name: 'calendar-event',
    component: Calendar,
  },
  {
    path: '/calendar/',
    name: 'calendar',
    component: Calendar,
  },
  {
    path: '/assignments/:id',
    name: 'assignments-detail',
    component: Assignments,
  },
  {
    path: '/assignments/',
    name: 'assignments',
    component: Assignments,
  },
  {
    path: '/queue',
    name: 'queue',
    component: Queue,
  },
  {
    path: '/files/:path(.*)',
    name: 'files',
    component: Files,
  },
  { path: '/:pathMatch(.*)*', component: PathNotFound },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
